import React from 'react';
import Modal from 'antd/lib/modal/Modal';
import * as S from '../styles';

export function ModalBanner({ open, setOpen }) {
  return (
    <Modal
      centered
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      width="600px"
    >
      <S.DivDisplayFlex width="95%" alignItems="flex-start">
        <S.StartMessageH1 fontSize="28px">
          Entre na rede do portal de informações
        </S.StartMessageH1>
      </S.DivDisplayFlex>
      <S.DivDisplayFlex width="95%" alignItems="flex-start">
        <S.StartMessageP fontSize="14px" textAlign="left" color="black">
          Quer garantir maior agilidade nas suas operações de gerenciamento de
          risco?
{' '}
<br />
A integração com o portal de informações pode agilizar a
          busca de informações sobre os motoristas.
        </S.StartMessageP>
        <S.StartMessageP fontSize="14px" textAlign="left" color="black">
          Fale com o seu gerente de gerenciamento de risco para contatar através
          do e-mail
{' '}
          <S.HyperLink href="mailto:comercial.gr@tmov.com.br">
            comercial.gr@tmov.com.br
          </S.HyperLink>
{' '}
          e saber como fazer parte da rede do portal de informações.
        </S.StartMessageP>
      </S.DivDisplayFlex>
    </Modal>
  );
}
